import api from './index';

const remoteApi = api.injectEndpoints({
  endpoints: build => ({
    fetchRemoteLayout: build.query({
      query: name => ({
        method: 'GET',
        url: `/api/v1/remote-layout?name=${name}`,
      }),
      providesTags: (result, error, arg) => [
        { type: 'remoteLayout', id: arg || 'LIST' },
      ],
    }),
    fetchRemotePodMapping: build.query({
      query: () => ({
        method: 'GET',
        url: `/api/v1/remote-pod-map`,
      }),
      providesTags: (result, error, arg) => [
        { type: 'remotePodMapping', id: arg || 'LIST' },
      ],
    }),
    createRemoteLayout: build.mutation({
      query: body => ({
        method: 'POST',
        url: `/api/v1/remote-layout`,
        body,
      }),
      invalidatesTags: () => [{ type: 'remoteLayout', id: 'LIST' }],
    }),
    updateRemoteLayout: build.mutation({
      query: body => ({
        method: 'PUT',
        url: `/api/v1/remote-layout/${body.name}`,
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'remoteLayout', id: 'LIST' },
        { type: 'remoteLayout', id: arg.name },
      ],
    }),
    updateRemotePodMapping: build.mutation({
      query: body => ({
        method: 'POST',
        url: `/api/v1/remote-pod-map`,
        body,
      }),
      invalidatesTags: () => [{ type: 'remotePodMapping', id: 'LIST' }],
    }),
    deleteRemoteLayout: build.mutation({
      query: ({ name }) => ({
        method: 'DELETE',
        url: `/api/v1/remote-layout/${name}`,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'remoteLayout', id: 'LIST' },
        { type: 'remoteLayout', id: arg.name },
      ],
    }),
  }),
});

export const {
  useCreateRemoteLayoutMutation,
  useDeleteRemoteLayoutMutation,
  useFetchRemoteLayoutQuery,
  useUpdateRemoteLayoutMutation,
  useFetchRemotePodMappingQuery,
  useUpdateRemotePodMappingMutation,
} = remoteApi;
